<div class="dashboard-section" [ngClass]="{ 'mt-[115px]!': userService.showRepairerWarningBanner() }">
  @if (repairerSite?.status === 'PENDING') {
    <div class="guidance-message-container">
      <mat-card class="flex-row!">
        <mat-icon>error_outline</mat-icon>
        @if (currentUser?.privileges?.includes('REPADMIN')) {
          <span>
            You will be able to manage your EstImage jobs here once your location has been published. Head to
            <a routerLink="/locationAdmin">Administration</a> to get started.
          </span>
        } @else {
          <span
            >You will be able to manage your EstImage jobs here once your site administrator has published your
            location.</span
          >
        }
      </mat-card>
    </div>
  }
  <mat-tab-group
    (selectedTabChange)="tabSelected($event); historyCount = 25"
    animationDuration="0ms"
    class="dashboard-group"
    [selectedIndex]="selectedTabIndex()"
    #tabGroup>
    <mat-tab #quotesTab>
      <ng-template mat-tab-label>
        <div class="title-1" [ngClass]="{ 'text-red!': quotesTab.isActive }">Quoting</div>
        <div [ngClass]="{ 'red-background': quotesTab.isActive }" class="section-counter subtitle-1">
          <span>{{ quotesTabCounter() }}</span>
        </div>
      </ng-template>
      <div class="section-container">
        <app-tab-headers
          [bucketDetails]="quotingBucketDetails()"
          [dates]="{ oldestReceivedOn: oldestReceivedOn, newestReceivedOn: newestReceivedOn, timezone: timezone }"
          [bucketSelected]="bucketSelected"
          [unreadJobFilter]="unreadJobFilter"
          (filterUnreadJobs)="updateBucketsByUnreadStatus($event)"
          (scrollBucket)="scrollBucket($event)">
        </app-tab-headers>
        @for (quotingBucket of quotingBuckets(); track quotingBucket.id) {
          <app-repairer-buckets [bucket]="quotingBucket" (getJobs)="getJobs()" />
        }
      </div>
    </mat-tab>
    <mat-tab #workInProgressTab>
      <ng-template mat-tab-label>
        <div class="title-1" [ngClass]="{ 'text-red!': workInProgressTab.isActive }">Work Authorised</div>
        <div [ngClass]="{ 'red-background': workInProgressTab.isActive }" class="section-counter subtitle-1">
          <span>{{ wipTabCounter }}</span>
        </div>
      </ng-template>
      <div class="section-container">
        <app-tab-headers
          [bucketDetails]="workAuthorisedBucketDetails()"
          [dates]="{ oldestReceivedOn: oldestReceivedOn, newestReceivedOn: newestReceivedOn, timezone: timezone }"
          [bucketSelected]="bucketSelected"
          [unreadJobFilter]="unreadJobFilter"
          (filterUnreadJobs)="updateBucketsByUnreadStatus($event)"
          (scrollBucket)="scrollBucket($event)">
        </app-tab-headers>
        @for (workAuthorisedBucket of workAuthorisedBuckets(); track workAuthorisedBucket.id) {
          <app-repairer-buckets [bucket]="workAuthorisedBucket" (getJobs)="getJobs()" />
        }
      </div>
    </mat-tab>
    <mat-tab #invoicesTab>
      <ng-template mat-tab-label>
        <div class="title-1" [ngClass]="{ 'text-red!': invoicesTab.isActive }">Invoicing</div>
        <div [ngClass]="{ 'red-background': invoicesTab.isActive }" class="section-counter subtitle-1">
          <span>{{ invoicesTabCounter }}</span>
        </div>
      </ng-template>
      <div class="section-container">
        <app-tab-headers
          [bucketDetails]="invoicingBucketDetails()"
          [dates]="{ oldestReceivedOn: oldestReceivedOn, newestReceivedOn: newestReceivedOn, timezone: timezone }"
          [bucketSelected]="bucketSelected"
          [unreadJobFilter]="unreadJobFilter"
          (filterUnreadJobs)="updateBucketsByUnreadStatus($event)"
          (scrollBucket)="scrollBucket($event)">
        </app-tab-headers>
        @for (invoicingBucket of invoicingBuckets(); track invoicingBucket.id) {
          <app-repairer-buckets [bucket]="invoicingBucket" (getJobs)="getJobs()" />
        }
      </div>
    </mat-tab>
    <mat-tab #repairProgressTab [labelClass]="['repairer-progress', !repairPickUpAvailable ? 'no-pickup-job' : '']">
      <ng-template mat-tab-label>
        <div class="title-1" [ngClass]="{ 'text-red!': repairProgressTab.isActive }">Repairs Progress</div>
        <div [ngClass]="{ 'red-background': repairProgressTab.isActive }" class="section-counter subtitle-1">
          <span>{{ rpTabCounter }}</span>
        </div>
      </ng-template>
      @if (selectedTabIndex() === 3) {
        <div class="section-container">
          @if (loadingJobs) {
            <div class="section-container-spinner h-[80vh]!">
              <mat-spinner mode="indeterminate" />
            </div>
          }
          @if (!loadingJobs && jobs?.repairProgressJobs) {
            <app-repair-progress [buckets]="jobs?.repairProgressJobs" (updateBuckets)="updateBuckets($event)" />
          }
        </div>
      }
    </mat-tab>
    <mat-tab #jobHistoryTab [labelClass]="['history', !repairPickUpAvailable ? 'no-pickup-job' : '']">
      <ng-template mat-tab-label>
        <mat-icon class="history-tab" [ngClass]="{ 'text-red!': jobHistoryTab.isActive }">history</mat-icon>
      </ng-template>
      @if (jobHistory) {
        <app-job-history-tab
          [jobHistory]="jobHistory"
          [canLoadMore]="canLoadMore"
          [timezone]="timezone"
          (loadMoreItems)="loadMoreItems()"></app-job-history-tab>
      }
    </mat-tab>
    <mat-tab disabled [labelClass]="['import-config', !repairPickUpAvailable ? 'no-pickup-job' : '']">
      <ng-template mat-tab-label>
        <button
          matButton="filled"
          type="button"
          class="white-button w-36! min-w-36! p-0!"
          (click)="configureImportDirectories()">
          <mat-icon class="size-20! text-20! m-0!" svgIcon="folder_edit"></mat-icon>
        </button>
      </ng-template>
    </mat-tab>
    @if (repairPickUpAvailable) {
      <mat-tab disabled [labelClass]="'pick-up-job'">
        <ng-template mat-tab-label>
          <div
            [matTooltip]="repairerPickupUnavailableMessage()"
            [matTooltipDisabled]="!(userService.isRepairerSiteSuspended() || isRepairerSiteUnavailable())">
            <button
              matButton="elevated"
              class="white-button px-16!"
              (click)="pickupJob()"
              [disabled]="userService.isRepairerSiteSuspended() || isRepairerSiteUnavailable()">
              <div class="flex items-center justify-center gap-x-10">+ <mat-icon svgIcon="allianz"></mat-icon></div>
            </button>
          </div>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</div>
